import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { SITE_URL } from "./Seo";
import { SocialIcon } from "./SocialIcons";

export const ShareTrackButton = ({ track, testid = "share-track-btn", compact = false, className = "" }) => {
  const copyShare = async (e) => {
    e?.stopPropagation();
    const link = `${SITE_URL}/api/share/release/${track.id}`;
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Share link copied — paste it in WhatsApp or socials to show the track card.");
    } catch {
      toast.error(`Copy this link: ${link}`);
    }
  };
  if (compact) {
    return (
      <button
        onClick={copyShare}
        data-testid={testid}
        aria-label={`Share ${track.title}`}
        title="Share this track"
        className={`shrink-0 inline-flex items-center justify-center rounded-full border border-gold-400/40 p-2 text-gold-200 hover:bg-gold-400/10 transition-colors ${className}`}
      >
        <Share2 size={14} />
      </button>
    );
  }
  return (
    <button onClick={copyShare} data-testid={testid} className={`btn-ghost-gold !px-5 !py-2.5 text-xs ${className}`}>
      <Share2 size={15} /> Share this track
    </button>
  );
};


export const WhatsAppTrackButton = ({ track, testid = "whatsapp-track-btn", className = "" }) => {
  const share = (e) => {
    e?.stopPropagation();
    const link = `${SITE_URL}/api/share/release/${track.id}`;
    const text = `${track.title} - Open Horizon Records\n${link}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener,noreferrer");
  };
  return (
    <button
      onClick={share}
      data-testid={testid}
      aria-label={`Share ${track.title} on WhatsApp`}
      title="Share on WhatsApp"
      className={`shrink-0 inline-flex items-center justify-center rounded-full border border-gold-400/40 p-2 text-gold-200 hover:bg-gold-400/10 transition-colors ${className}`}
    >
      <SocialIcon name="whatsapp" size={14} />
    </button>
  );
};
